import { render, staticRenderFns } from "./homeSectionSocialsAnswers.vue?vue&type=template&id=5f152dd8&scoped=true&"
import script from "./homeSectionSocialsAnswers.vue?vue&type=script&lang=js&"
export * from "./homeSectionSocialsAnswers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f152dd8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VImg,VRow,VSheet})
